module.exports = __webpack_public_path__ + "static/worldmap-42c39391e8605cdd39d31f47328d973f.png";